import lowerCase from 'lodash/lowerCase'

export const isEnterOrNumpadEnter = event => event.key === 'Enter' || event.key === 'NumpadEnter'

export const isCtrlOrMeta = event => event.ctrlKey || event.metaKey

export const isEnterOrNumpadEnterWithCtrlOrMeta = event => isEnterOrNumpadEnter(event) && isCtrlOrMeta(event)

export const isSKeyWithCtrlOrMeta = event => lowerCase(event.key) === 's' && isCtrlOrMeta(event)
